import ActivityGraphStacked from './ActivityGraphStackedComponent'

export default ActivityGraphStacked
